import React, { useEffect, useState } from "react";
import { PiAddressBookTabs } from "react-icons/pi";
import { IoSearch } from "react-icons/io5";
import "../styles/MembershipManagement.css";
import GymTable from "../components/GymTable";
import axios from "axios";
import API_URL from "../config";
import { useNavigate } from "react-router-dom";
import { useAdmin } from "../contexts/AdminContext";
import Loading from "../components/Loading";

const MembershipManagement = () => {
  const { admin } = useAdmin();
  const [users, setUsers] = useState([]);
  const [searchTermMembership, setSearchTermMembership] = useState("");
  const [searchTermRenewal, setSearchTermRenewal] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsersByBranch = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/auth/branch/${admin?.branch}`
        );
        const sortedUsers = response.data.sort((a, b) => {
          return parseInt(a.memberId) - parseInt(b.memberId);
        });

        setUsers(sortedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersByBranch();
  }, [admin?.branch]);

  const handleSearchChangeMembership = (e) => {
    setSearchTermMembership(e.target.value);
  };

  const handleSearchChangeRenewal = (e) => {
    setSearchTermRenewal(e.target.value);
  };

  const filteredUsersMembership = users.filter((user) => {
    const fullName = user.fullName?.toLowerCase() || "";
    const memberId = user.memberId?.toLowerCase() || "";
    const phoneNo = user.phoneNo?.toString() || "";

    return (
      fullName.includes(searchTermMembership.toLowerCase()) ||
      memberId.includes(searchTermMembership.toLowerCase()) ||
      phoneNo.includes(searchTermMembership)
    );
  });

  const filteredUsersRenewal = users.filter((user) => {
    const trainerId = user.trainerId?.toLowerCase() || "";
    return trainerId.includes(searchTermRenewal.toLowerCase());
  });

  console.log(filteredUsersMembership);

  return (
    <div className="membershipManagementContainer">
      <div className="membershipManagementHeader">
        <div className="memberHeaderLeft">
          <PiAddressBookTabs
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>Membership Management</h2>
        </div>
        <div className="memberHeaderRight">
          <input
            placeholder="eg. Search by memberId, name and phone"
            onChange={handleSearchChangeMembership}
          />
          <div>
            <IoSearch />
          </div>
        </div>
      </div>

      <h3>Renewal & Membership Management:</h3>

      <div
        className="userMemberContainer"
        style={{ marginLeft: 20, marginTop: 30 }}
      >
        <h4>List view with renewal status for quick scanning:</h4>
        {loading ? (
          <Loading />
        ) : (
          <GymTable
            data={filteredUsersMembership}
            isEdit={true}
            from={"membershipManagement"}
            view={true}
          />
        )}
      </div>

      <div
        className="userMemberContainer"
        style={{ marginLeft: 20, marginTop: 40 }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3>Renewal Alerts:</h3>
          <div
            className="memberHeaderRight"
            style={{
              width: 400,
              display: "flex",
              alignItems: "center",
              border: "1px solid grey",
              borderRadius: 10,
            }}
          >
            <input
              placeholder="eg. Search by trainer name"
              onChange={handleSearchChangeRenewal}
              style={{ flex: 1, border: "none", borderRadius: 10 }}
            />
            <div
              style={{
                width: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <IoSearch size={24} />
            </div>
          </div>
          <p
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/admin/membershipmanagement/renewalalerts")
            }
          >
            View All
          </p>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <GymTable
            data={filteredUsersRenewal}
            allexpired={true}
            trainer={true}
          />
        )}
      </div>
    </div>
  );
};

export default MembershipManagement;
